import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  const tmpProduct = params.productList.map((ele) => {
    const tmpRackInfo = ele.rackNumberList
      .filter((ele2) => ele2.count > 0)
      .map((ele2) => {
        return {
          quantity: ele2.count,
          rackNumber: commonUtil.nullEmptyFormatNull(ele2.rackNumber)
        }
      })
    return { productId: ele.productId, rackInfoList: tmpRackInfo }
  })
  return {
    shipDate: params.pageInfoData.line1.shipDate,
    shipProductList: tmpProduct
  }
}
export default { request }
